// @flow

import React from 'react';
import { TranslationsProvider as UITranslationsProvider } from 'trpc-react-native-ui';
import { getTranslations } from './translations';

type TranslationsProviderProps = {
  children: any,
};

export default ({ children }: TranslationsProviderProps) => (
  <UITranslationsProvider translations={getTranslations()}>{children}</UITranslationsProvider>
);
